<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Laporan Purchase Order Semua Divisi</h2>

      <br />

      <form class="filter" @submit.prevent="loadData">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker
            v-model="dateRange"
            single-date-picker="true"
            :auto-apply="true"
          >
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label>&nbsp;</label>
          <button type="button" class="btn-fill" @click="loadData">
            Filter
          </button>
        </div>
        <div class="form-group"></div>
        <div class="form-group"></div>
        <div class="form-group">
          <label>Export Data</label>
          <button
            type="button"
            class="btn-outline"
            @click="exportExcel"
            :disabled="loadingExcel"
          >
            Export Excel
          </button>
        </div>
      </form>

      <div class="summary">
        <div>
          <div class="card">
            <div class="card-body">
              <h2>{{ totalItem }}</h2>
              <p>Total Item</p>
            </div>
          </div>
        </div>
        <div>
          <div class="card">
            <div class="card-body">
              <h2>Rp {{ totalPurchaseOrder | number }}</h2>
              <p>Total Purchase Order</p>
            </div>
          </div>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>No</th>
            <th>Divisi</th>
            <th>Bahan Baku</th>
            <th>Jumlah</th>
            <th>Harga Satuan</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ ++index }}</td>
            <td>{{ item.divisi || "-" }}</td>
            <td>{{ item.bahan_baku }}</td>
            <td>{{ item.jumlah }}</td>
            <td>Rp {{ item.harga | number }} / {{ item.satuan }}</td>
            <td>Rp {{ (item.jumlah * item.harga) | number }}</td>
          </tr>
          <tr class="empty" v-if="data.length <= 0">
            <td colspan="6">
              <p>
                Tidak ada data untuk ditampilkan. <br />
                Gunakan filter untuk melihat data di tanggal lainnya
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "../../api/Api";
import moment from "moment";
import _ from "lodash";

export default {
  name: "Home",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      loadingExcel: false,
      data: [],
      summary: {},
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        tgl_awal: moment().format("YYYY-MM-DD"),
        tgl_akhir: moment().format("YYYY-MM-D"),
        pembayaran: "ALL",
      },
    };
  },
  computed: {
    totalNota() {
      const data = _.groupBy(this.data, "id");
      return Object.keys(data).length;
    },
    totalItem() {
      let total = 0;
      this.data.forEach((item) => {
        total += parseInt(item.jumlah);
      });
      return total;
    },
    totalPurchaseOrder() {
      let total = 0;
      this.data.forEach((item) => {
        total += parseInt(item.harga) * parseInt(item.jumlah);
      });

      return total;
    },
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      this.filter.id_toko = this.$toko.id;
      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      api
        .get("/v1/purchase/get-divisi?" + this.$objectToQuery(this.filter))
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    exportExcel() {
      if (this.data.length <= 0) {
        this.$toast("Tidak ada data untuk didownload");
        return;
      }

      this.loadingExcel;
      api
        .get("/v1/purchase/excel-divisi?" + this.$objectToQuery(this.filter))
        .then((r) => {
          this.loadingExcel = false;
          if (r.valid) {
            location.href = r.filename;
          }
        })
        .catch((e) => {
          this.loadingExcel = false;
        });
    },
  },
  mounted() {
    this.$store.commit("settings/setMenuActive", "/laporan/purchase-order-harian");
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 20px;
    margin-bottom: 20px;
    padding-bottom: 0px;
    border-bottom: 1px solid #ccc;
  }
  .summary {
    display: grid;
    margin-bottom: 20px;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;

    .card-body {
      p,
      h2 {
        margin: 0;
      }

      h2 {
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
      }
    }
  }
  table {
    tr.empty {
      td {
        p {
          text-align: center;
          padding: 100px 0;
        }
      }
    }
  }
}
</style>
<style>
.daterangepicker.single.show-ranges {
  min-width: 375px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/PurchaseOrderHarian.vue